import { Callout, ExternalLink } from "@octopusdeploy/design-system-components";
import { ActionExecutionLocation } from "@octopusdeploy/octopus-server-client";
import { TargetRoles } from "~/areas/projects/components/Process/types";
import pluginRegistry from "../pluginRegistry";
const warningCallout = (<Callout type={"danger"} title={"Step No Longer Supported"}>
        Azure Cloud Service Step are no longer supported. Please remove it before running this process.
    </Callout>);
const goodWarning = (<Callout type={"danger"} title="Step No Longer Supported">
        Azure has announced that Cloud Services are now a legacy service and <i>Service Fabric</i> is recommended for new development.
        <br />
        <br />
        Please consider <ExternalLink href="WindowsAzure">alternate applications</ExternalLink> that you can deploy to and remove this step before running this process.
    </Callout>);
pluginRegistry.registerAction({
    executionLocation: ActionExecutionLocation.AlwaysOnServer,
    actionType: "Octopus.AzureCloudService",
    summary: (properties, targetRolesAsCSV, packages) => warningCallout,
    editSections: { default: () => goodWarning },
    canHaveChildren: (step) => false,
    targetRoleOption: (action) => TargetRoles.None,
    canBeChild: true,
    hasPackages: (action) => true,
});
